module.exports = __webpack_public_path__ + "static/img/monitor-img.74326f31.png";